import Modal from 'libs/components/modal';

export default {
  init : function(_element) {
    $('[data-profile-changes-isolated=true]').on('click', function(e){
      if ($(this).closest('.btn--success').length)
        return;

      Modal.for('confirmation', {
        title: I18n.t('modals.profile.title'),
        body: I18n.t('modals.profile.body'),
        hideCancel: true,
        okBtnText: I18n.t('modals.profile.ok_btn_text')
      });
    });
  }
};
